import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className={`text-xl font-bold font-heading transition-colors duration-300 ${
              scrolled || !isHome ? 'text-foreground-900' : 'text-background-50'
            }`}>
              韩漫大全
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap ${
                scrolled || !isHome ? 'text-foreground-700 hover:text-accent-500' : 'text-background-50/90 hover:text-background-50'
              } ${location.pathname === '/' ? (scrolled || !isHome ? 'text-accent-500' : 'text-background-50') : ''}`}
            >
              首页
            </Link>
            <Link
              to="/category/love"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap ${
                scrolled || !isHome ? 'text-foreground-700 hover:text-accent-500' : 'text-background-50/90 hover:text-background-50'
              } ${location.pathname.startsWith('/category') ? (scrolled || !isHome ? 'text-accent-500' : 'text-background-50') : ''}`}
            >
              分类
            </Link>
            <Link
              to="/category/fantasy"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap ${
                scrolled || !isHome ? 'text-foreground-700 hover:text-accent-500' : 'text-background-50/90 hover:text-background-50'
              }`}
            >
              排行
            </Link>
            <Link
              to="/category/action"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap ${
                scrolled || !isHome ? 'text-foreground-700 hover:text-accent-500' : 'text-background-50/90 hover:text-background-50'
              }`}
            >
              最新
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap ${
                scrolled || !isHome ? 'text-foreground-700 hover:text-accent-500' : 'text-background-50/90 hover:text-background-50'
              } ${location.pathname === '/about' ? (scrolled || !isHome ? 'text-accent-500' : 'text-background-50') : ''}`}
            >
              关于我们
            </Link>
          </div>

          <Link
            to="/category/love"
            className={`whitespace-nowrap cursor-pointer px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
              scrolled || !isHome
                ? 'bg-foreground-900 text-background-50 hover:bg-foreground-800'
                : 'bg-background-50/20 text-background-50 border border-background-50/30 hover:bg-background-50/30'
            }`}
          >
            开始阅读
          </Link>

          <button
            className="md:hidden cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`ri-menu-line text-xl ${
              scrolled || !isHome ? 'text-foreground-900' : 'text-background-50'
            }`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden py-4 border-t border-background-200/60 bg-background-50 absolute left-0 right-0 top-16 px-4">
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm font-medium text-foreground-700 py-2">首页</Link>
              <Link to="/category/love" className="text-sm font-medium text-foreground-700 py-2">分类</Link>
              <Link to="/category/fantasy" className="text-sm font-medium text-foreground-700 py-2">排行</Link>
              <Link to="/category/action" className="text-sm font-medium text-foreground-700 py-2">最新</Link>
              <Link to="/about" className="text-sm font-medium text-foreground-700 py-2">关于我们</Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}